import React, { type ComponentProps, memo, useCallback } from 'react';

import { theme } from '@garnish/constants';
import { IconLink } from '@garnish/core';

import { ICON_CONTAINER_SIZE, ICON_SIZE } from '../../CustomizationActiveIngredient.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientRemoveButton = memo((props: Props) => {
  const { ingredientId, onPress, ...restProps } = props;

  // ─── Helpers ─────────────────────────────────────────────────

  const handleOnPress = useCallback(() => {
    onPress(ingredientId);
  }, [ingredientId, onPress]);

  // ─────────────────────────────────────────────────────────────

  return (
    <IconLink
      name="IconClose"
      color={theme.colors.DARK_KALE}
      width={ICON_CONTAINER_SIZE}
      height={ICON_CONTAINER_SIZE}
      iconSize={ICON_SIZE}
      palette="muted"
      onPress={handleOnPress}
      {...restProps}
    />
  );
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  ingredientId: string;
  onPress: (ingredientId: string) => void;
} & Omit<ComponentProps<typeof IconLink>, 'name' | 'onPress'>;
